module.exports = __webpack_public_path__ + "img/bitcoin-bg.4b4b06db.png";